import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {labels} from '../../../../util/utils';
import AssociatedRiskAccountItem from './AssociatedRiskAccountItem';
import _ from 'lodash';

const AssociatedRiskAccountList = (props) => {
	const dispatch = useDispatch();

	// Redux States.
	const accounts = useSelector((state) => state.accounts);
	// Local states.
	const [sortedAccountList, setSortedAccountList] = useState([]);

	useEffect(() => {
		if (props.assertionList.length > 0 && accounts.allIds && accounts.allIds.length > 0) {
			const availableAccounts = props.assertionList.map((element) => {
				return getAccountInfo(element.account.key);
			});
			setSortedAccountList(_.orderBy(availableAccounts, [(account) => account.accountName.toLowerCase()], ['asc']));
		}
	}, [props.assertionList, accounts]);

	const getAccountInfo = (accountId) => {
		const account = accounts.byId[accountId];
		return {...account};
	};

	const getAssertionResults = (accountId) => {
		return [...props.assertionList.find((x) => x.account.key === accountId.toString()).assertionResults];
	};

	return (
		<>
			{sortedAccountList.length > 0 ? (
				sortedAccountList.map((x) => {
					return (
						<AssociatedRiskAccountItem
							accountName={x.accountName}
							statementTypeId={x.statementTypeId}
							selectedAssertions={getAssertionResults(x.id)}
						/>
					);
				})
			) : (
				<span className="noacc-linked">{labels.assessRiskNoAccountsLinked}</span>
			)}
		</>
	);
};

export default AssociatedRiskAccountList;
